import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  Card, CardText, RaisedButton, Table, TableHeader, TableRow, TableHeaderColumn,
  TableBody, TableRowColumn, CircularProgress
} from "material-ui";
import { GetFileDetalleSolicitudExcel, getDetalleSolBOConvnioReajusteExcel, LoadingFile, GetDetalleSolicitudConvenioPaquete, GetDetalleSolicitudConvenioPaqueteR } from "./actions";
import { ObtenerEstadosSolicitud, ObtenerTiposSolicitud } from "../../Global/actions";
import { OpenModalVerDetalle } from "../GrillaSolicitudes/actions";
import styles from "../../styles/styles";
import TablePaginationCustom from "../../TablePagination/view";

class DetalleSolicitud extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerEstadosSolicitud());
    this.props.dispatch(ObtenerTiposSolicitud());
  }

  CloseModalVerDetalle = () => {
    this.props.dispatch(OpenModalVerDetalle(false, null));
  }

  GetFileDetalleSolicitud = () => {
    this.props.dispatch(LoadingFile(true))
    switch (this.props.tipoSolicitud) {
      case 12:
        this.props.dispatch(getDetalleSolBOConvnioReajusteExcel(this.props.idSolicitudDetalle));
        break;
      case 71:
        this.props.dispatch(GetDetalleSolicitudConvenioPaquete(this.props.idSolicitudDetalle));
        break;
      case 69:
        this.props.dispatch(GetDetalleSolicitudConvenioPaqueteR(this.props.idSolicitudDetalle));
        break;
      default:
        this.props.dispatch(GetFileDetalleSolicitudExcel(this.props.idSolicitudDetalle));
    }
  }

  GetTipoSolicitud = (tipoS) => {
    const glosatipoS = this.props.tiposSolicitud.filter((ts) => ts.Id === tipoS);
    if (glosatipoS && glosatipoS.length === 1) {
      return glosatipoS[0].Nombre;
    }
    return "-";
  }

  IsReajuste = () => this.props.tipoSolicitud === 12 || this.props.tipoSolicitud === 69
  IsReajustePaquetes = () => this.props.tipoSolicitud === 69


  GetEstadoSolicitud = (estadoS) => {
    const glosaestadoS = this.props.estadosSolicitud.filter((ts) => ts.Id === estadoS);
    if (glosaestadoS && glosaestadoS.length === 1) {
      return glosaestadoS[0].Nombre;
    }
    return "-";
  }

  GetFormatDateRow = (dateRow) => {
    try {
      if (typeof dateRow.getMonth === "function") {
        return (new Date(dateRow)).toLocaleDateString("en-GB", { timeZone: "UTC" });
      }
      if (!Number.isNaN((new Date(dateRow)).getDate())) {
        return (new Date(dateRow)).toLocaleDateString("en-GB", { timeZone: "UTC" });
      }
    } catch (errorDate) {
      return dateRow || "-";
    }
    return dateRow || "-";
  }

  render() {
    const { estadoSolicitud } = this.props;

    //console.log('PRESTACIONES', this.props.prestaciones);
    const menuListDetalleSolicitud = [];
    const menuListDetalleSolicitudRPQ = [];
    const itemsInfoPaquete = [];
    const itemsCaracteristicas = [];
    const itemsPrestaciones = [];

    //console.log('PRESTACIONES: ', this.props.prestaciones);
    if (!this.IsReajustePaquetes()) {
      this.props.prestaciones.forEach((element, index) => {
        let glosaGrupoPrestacionPrestador = element.GlosaGrupoPrestacionPrestador;
        glosaGrupoPrestacionPrestador = glosaGrupoPrestacionPrestador === "NO ENCONTRADO" ? "-" : glosaGrupoPrestacionPrestador;

        let estadoResolucion = "";
        if (element.IdEstadoResolucionConvenio === 3) estadoResolucion = "Rechazado Convenio";
        else if (element.IdEstadoResolucionContraloria === 3) estadoResolucion = "Rechazado Aranceles";
        else if (element.IdEstadoResolucionConvenio === 2) estadoResolucion = "Aprobado";
        else estadoResolucion = "Pendiente";

        menuListDetalleSolicitud.push((
          <TableRow selectable={false} key={`tablaDetalleSolicitudDetalle${index}`} >
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.CodigoPrestacionPrestador}</TableRowColumn> : null}
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.GuarismoDP}</TableRowColumn> : null}
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} title={element.GlosaPrestacionPrestador} >{element.GlosaPrestacionPrestador}</TableRowColumn> : null}
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.CodigoFonasa}</TableRowColumn> : null}
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.CodigoPrestacionIsapre}</TableRowColumn> : null}

            <TableRowColumn style={styles.contTablaSolicitudesDetalle} title={glosaGrupoPrestacionPrestador} >{glosaGrupoPrestacionPrestador}</TableRowColumn>
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.CodigoProfesionalIsapre}</TableRowColumn> : null}
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} title={element.ItemImed} >{element.ItemImed}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.ValorPosterior}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.TipoAtencion}</TableRowColumn>
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.UnidadPosterior}</TableRowColumn> : null}
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{this.GetFormatDateRow(element.FechaInicioVigenciaAnterior)}</TableRowColumn> : null}
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{this.props.rutInstitucion}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} title={element.CentroAtencion || element.CentroAtencionNombre} >{element.CentroAtencion || element.CentroAtencionNombre}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} title={element.GlosaArancel}>{element.GlosaArancel}</TableRowColumn>
            {!this.IsReajuste() ? <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.TipoAccionPrestacion}</TableRowColumn> : null}

            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.IdDetallePrestacionSolicitud || element.IdSolicitudDetalle}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >
              {
                estadoSolicitud == 9 || estadoSolicitud == 6 ?
                  estadoSolicitud == 9 ? 'En revisión' : 'En edición'
                  :
                  estadoResolucion
              }
            </TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >
              {element.IdTipoAccionPrestacion === 2 ?
                this.GetFormatDateRow(element.FechaTerminoVigenciaPosterior)
                :
                this.GetFormatDateRow(element.FechaInicioVigenciaPosterior)}
            </TableRowColumn>
            {this.props.estadoSolicitud === 10 ?
              <TableRowColumn style={styles.contTablaSolicitudesDetalle} >
                {element.IdEstadoResolucionConvenio === 3 || element.IdEstadoResolucionContraloria === 3 ?
                  element.ObservacionConvenio || element.ObservacionContraloria : ""}
              </TableRowColumn>
              : <TableRowColumn></TableRowColumn>}
          </TableRow>
        ));
      });
    }

    if (this.IsReajustePaquetes()) {
      this.props.prestaciones.forEach((element, index) => {
        let estadoResolucion = "";
        if (element.IDESTADORESOLUCION === 3) estadoResolucion = "Rechazado Convenio";
        else if (element.IDESTADORESOLUCION === 2) estadoResolucion = "Aprobado";
        else estadoResolucion = "Pendiente";

        menuListDetalleSolicitud.push((
          <TableRow selectable={false} key={`tablaDetalleSolicitudDetalle${index}`} >
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{this.props.rutInstitucion}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.ARANCEL}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.NOMBREARANCEL}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.FECHAINICIOACTUAL}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.VALORREAJUSTE}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{element.ID_DET_PAQUETE_REA}</TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >
              {
                estadoSolicitud == 9 || estadoSolicitud == 6 ?
                  estadoSolicitud == 9 ? 'En revisión' : 'En edición'
                  :
                  estadoResolucion
              }
            </TableRowColumn>
            <TableRowColumn style={styles.contTablaSolicitudesDetalle} >{this.GetFormatDateRow(element.PAQU_INICIO_VIGENCIA)}</TableRowColumn>
            {this.props.estadoSolicitud === 10 ?
              <TableRowColumn style={styles.contTablaSolicitudesDetalle} >
                {element.IDESTADORESOLUCION === 3 ?
                  element.OBSERVACION : ""}
              </TableRowColumn>
              : <TableRowColumn></TableRowColumn>}
          </TableRow>
        ));
      });
    }

    this.props.prestaciones.forEach((row, index) => {
      let estadoResolucion = row.ESTADORESOLUCION || "Pendiente";
      let fechaResolucion = row.FECHARESOLUCION || "--";
      itemsInfoPaquete.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRTA_NRUT_INSTITUCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRTA_NSECUEN_INSTITUCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_CODIGO}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_DESCRIPCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_CODIGO_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_DESC_PRESTADOR}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAAT_CCOD_OLD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRES_CCOD_INTERV}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRES_CCOD_INTERV_PRES}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRES_TDESC_INTERV_PRES}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_INICIO_VIGENCIA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_TERMINO_VIGENCIA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ISAP_CEMPRESA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ID_DET_PAQUETE}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{estadoResolucion}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{fechaResolucion}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.OBSERVACION}</TableRowColumn>
        </TableRow>
      ));
    });

    this.props.prestaciones2.forEach((row, index) => {
      let estadoResolucion = row.ESTADORESOLUCION || "Pendiente";
      let fechaResolucion = row.FECHARESOLUCION || "--";

      itemsCaracteristicas.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRTA_NRUT_INSTITUCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRTA_NSECUEN_INSTITUCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_CODIGO}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.TICA_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.TICA_DESCRIPCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_INICIO_VIGENCIA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ISAP_CEMPRESA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ID_DET_CARACTERISTICA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{estadoResolucion}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{fechaResolucion}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.OBSERVACION}</TableRowColumn>
        </TableRow>
      ));
    });

    this.props.prestaciones3.forEach((row, index) => {
      let estadoResolucion = row.ESTADORESOLUCION || "Pendiente";
      let fechaResolucion = row.FECHARESOLUCION || "--";

      itemsPrestaciones.push((
        <TableRow key={index}>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRTA_NRUT_INSTITUCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRTA_NSECUEN_INSTITUCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_CODIGO}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRES_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PRES_CCOD_PRES}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.TDESC_CCOD_PRES}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ITEM_IMED_PRES}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PROF_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PADE_CANT_PREST}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PADE_PRECIO}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PADE_UNID_CCOD}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PADE_TATENCION}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PADE_XMEDICO_HOTELERIA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PADE_RUT_BONO}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.PAQU_INICIO_VIGENCIA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ISAP_CEMPRESA}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.ID_DET_PAQUETE_PRES}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{estadoResolucion}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{fechaResolucion}</TableRowColumn>
          <TableRowColumn style={styles.contTablaSolicitudesDetalle}>{row.OBSERVACION}</TableRowColumn>
        </TableRow>
      ));
    });

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>
                    Detalle Solicitud
                  </div>
                  <div style={styles.h3}>
                    ID SOLICITUD: {this.props.idSolicitudDetalle}
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0, marginTop: 15, marginBottom: 10 }}>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.tituloReajustarPrestacionIpc}>Fecha Solicitud
                  </div>
                  <div style={styles.datoReajustarPrestacionIpc}>{(new Date(this.props.fechaSolicitud)).toLocaleDateString()}
                  </div>
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.tituloReajustarPrestacionIpc}>Tipo de Solicitud
                  </div>
                  <div style={styles.datoReajustarPrestacionIpc}>{this.GetTipoSolicitud(this.props.tipoSolicitud)}
                  </div>
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.tituloReajustarPrestacionIpc}>Estado Solicitud
                  </div>
                  <div style={styles.datoReajustarPrestacionIpc}>{this.GetEstadoSolicitud(this.props.estadoSolicitud)}
                  </div>
                </div>
                <div className="col-3" style={styles.colSelectFieldActualizar}>
                  <div style={styles.tituloReajustarPrestacionIpc}>Fecha de Resolución
                  </div>
                  <div style={styles.datoReajustarPrestacionIpc}>{this.props.fechaResolucion}
                  </div>
                </div>
              </div>
              <div className="" style={{ overflow: "auto" }}>
                {this.props.tipoSolicitud !== 71 ?
                  <div className="" style={{ width: this.IsReajuste() ? "1500px" : "2500px" }}>
                    <Table
                      key="tablaDetalleSolicitud"
                      id="tablaDetalleSolicitud"
                      name="tablaDetalleSolicitud"
                      fixedHeader
                      selectable={false}
                    >
                      <TableHeader adjustForCheckbox={false} displaySelectAll={false} >
                        <TableRow selectable={false}>
                          {this.IsReajustePaquetes() ?
                            <TableHeaderColumn colSpan={this.IsReajuste() ? 5 : 15}></TableHeaderColumn> :
                            <TableHeaderColumn colSpan={this.IsReajuste() ? 7 : 15}></TableHeaderColumn>}
                          <TableHeaderColumn colSpan={4} style={{ borderLeft: "1px solid rgb(224, 224, 224)" }}>Resolución</TableHeaderColumn>
                        </TableRow>
                        {!this.IsReajustePaquetes() ?
                          <TableRow selectable={false}>
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Prestación</TableHeaderColumn> : null}
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Guarismo de DP o Sala de Procedimiento</TableHeaderColumn> : null}
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Glosa Prestación</TableHeaderColumn> : null}
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Fonasa</TableHeaderColumn> : null}
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Isapre</TableHeaderColumn> : null}
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Tipo de Prestación</TableHeaderColumn>
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Profesional</TableHeaderColumn> : null}
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle}>Item IMED</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >{this.IsReajuste() ? "Valor reajuste" : "Valor prestación"}</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Tipo Atención</TableHeaderColumn>
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Unidad</TableHeaderColumn> : null}
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio vigencia actual</TableHeaderColumn> : null}
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Rut Institución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Centro de Atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Arancel</TableHeaderColumn>
                            {!this.IsReajuste() ? <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Tipo de Modificación</TableHeaderColumn> : null}

                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >N° Solicitud detalle</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Estado Resolución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio de Vigencia del cambio</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Observaciones</TableHeaderColumn>
                          </TableRow> :
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Rut Institución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Arancel</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Tipo de Arancel</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Vigencia a Reajustar	</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Valor Reajuste</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >N° Solicitud detalle</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Estado Resolución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio de Vigencia del cambio</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Observaciones</TableHeaderColumn>
                          </TableRow>
                        }

                      </TableHeader>
                      <TableBody
                        displayRowCheckbox={false}
                        deselectOnClickaway={false}
                        showRowHover
                        stripedRows={false}
                        id="tablaBodyDetalleSolicitud"
                      >
                        {menuListDetalleSolicitud}
                      </TableBody>
                    </Table>
                  </div>
                  : <div className="" style={{ width: "2500px" }}>
                    {this.props.prestaciones.length > 0 && this.props.prestaciones[0].MODIFICA_INFO === 'S' ?
                      <Table
                        key="tablaSolicitudeDetalleInbox"
                        fixedHeader
                        selectable={false}
                      >
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false} >
                          <TableRow selectable={false}>
                            <TableHeaderColumn colSpan={13}>Información del Paquete</TableHeaderColumn>
                            <TableHeaderColumn colSpan={4} style={{ borderLeft: "1px solid rgb(224, 224, 224)" }}>Resolución</TableHeaderColumn>
                          </TableRow>
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Rut Institución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Secuencia Centro de Atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Paquete</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Glosa Paquete</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Paquete Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Glosa Paquete Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Atributo Paquete</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Intervención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Intervención Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Glosa Intervención Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha fin vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Isapre</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >N° Solicitud detalle</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Estado Resolución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio de Vigencia del cambio</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Observaciones</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          id="tablaBodydetalle"
                          displayRowCheckbox={false}
                          deselectOnClickaway={false}
                          showRowHover
                          stripedRows={false}
                        >
                          {itemsInfoPaquete}
                        </TableBody>
                      </Table> : null}
                    {this.props.prestaciones2.length > 0 ?
                      <Table
                        key="tablaSolicitudeDetalleInbox2"
                        fixedHeader
                        selectable={false}
                      >
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false} >
                          <TableRow style={{ borderTop: "1px solid rgb(224, 224, 224)" }} selectable={false}>
                            <TableHeaderColumn colSpan={7}>Características del Paquete</TableHeaderColumn>
                            <TableHeaderColumn colSpan={4} style={{ borderLeft: "1px solid rgb(224, 224, 224)" }}>Resolución</TableHeaderColumn>
                          </TableRow>
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Rut Institución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Secuencia Centro de Atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Paquete</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Tipo Atributo</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Descripción</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Isapre</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >N° Solicitud detalle</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Estado Resolución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio de Vigencia del cambio</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Observaciones</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          id="tablaBodydetalle2"
                          displayRowCheckbox={false}
                          deselectOnClickaway={false}
                          showRowHover
                          stripedRows={false}
                        >
                          {itemsCaracteristicas}
                        </TableBody>
                      </Table> : null}
                    {this.props.prestaciones3.length > 0 ?
                      <Table
                        key="tablaSolicitudeDetalleInbox3"
                        fixedHeader
                        selectable={false}
                      >
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false} >
                          <TableRow style={{ borderTop: "1px solid rgb(224, 224, 224)" }} selectable={false}>
                            <TableHeaderColumn colSpan={16}>Prestaciones del Paquete</TableHeaderColumn>
                            <TableHeaderColumn colSpan={4} style={{ borderLeft: "1px solid rgb(224, 224, 224)" }}>Resolución</TableHeaderColumn>
                          </TableRow>
                          <TableRow selectable={false}>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Rut Institución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Secuencia Centro de Atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Paquete</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Prestación Isapre</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código Prestación Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Glosa Prestación Prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Item IMED prestador</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Código profesional</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Cantidad</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Monto unitario</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Unidad</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Tipo atención</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Médico u Hoteleria</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Bono RUT</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio vigencia</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Isapre</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >N° Solicitud detalle</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Estado Resolución</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Fecha inicio de Vigencia del cambio</TableHeaderColumn>
                            <TableHeaderColumn style={styles.tituloTablaSolicitudesDetalle} >Observaciones</TableHeaderColumn>
                          </TableRow>
                        </TableHeader>
                        <TableBody
                          id="tablaBodydetalle3"
                          displayRowCheckbox={false}
                          deselectOnClickaway={false}
                          showRowHover
                          stripedRows={false}
                        >
                          {itemsPrestaciones}
                        </TableBody>
                      </Table> : null}
                  </div>}
              </div>

              <TablePaginationCustom
                key={`pag_tablaDetalleSolicitud_${this.props.prestaciones.length}`}
                rowsPerPageDefault={5} // [5,10,15,20,25]
                totalRows={this.props.prestaciones.length}
                pageDefault={1}
                idTableBody="tablaBodyDetalleSolicitud"
                showRowsPerPage={false}
                labelStyleBtnPage={{ fontSize: "11px" }}
                overlayStyleBtnPage={{ borderRadius: 20 }}
                rippleStyleBtnPage={{ borderRadius: 20 }}
                buttonStyleBtnPage={{ borderRadius: 20 }}
                styleBtnPage={{
                  paddingLeft: 0,
                  paddingRight: 0,
                  paddingTop: 0,
                  paddingBottom: 0,
                  height: 25,
                  width: "45px",
                  minWidth: "45px",
                  borderRadius: 20,
                  marginRight: 5,
                }}

                labelStyleRowsPerPage={styles.h4}
                underlineStyleRowsPerPage={styles.underlineSelectField}
                iconStyleRowsPerPage={styles.iconSelectField}
                menuItemStyleRowsPerPage={styles.menuItemStyleSelectField}
                selectedMenuItemStyleRowsPerPage={styles.selectedMenuItemSelectField}
                styleRowsPerPage={styles.selectFiledStyle}
              />
              <div className="row">
                <div className="col-6" style={{ textAlign: "left", marginTop: 10, marginBottom: 10 }}>
                  <RaisedButton
                    label="Volver a Solicitudes"
                    onClick={this.CloseModalVerDetalle}
                    icon={<i className="material-icons">keyboard_arrow_left</i>}
                    backgroundColor="#fff"
                    overlayStyle={{ borderRadius: 5 }}
                    labelStyle={{
                      fontSize: "11px", color: "#757575", paddingLeft: 10, paddingRight: 5,
                    }}
                    style={{ width: "230px", borderRadius: 5 }}
                    buttonStyle={{ border: "2px solid #C3C3C3", borderRadius: 5 }}
                  />
                </div>
                <div className="col-6" style={{ textAlign: "right", marginTop: 10, marginBottom: 10 }}>
                  {
                    !this.props.loadingFile ?
                      <RaisedButton
                        label="Descargar Solicitud Realizada"
                        onClick={this.GetFileDetalleSolicitud}
                        secondary
                        labelStyle={{ fontSize: "11px" }}
                        overlayStyle={{ borderRadius: 5 }}
                        rippleStyle={{ borderRadius: 5 }}
                        style={{ width: "250px", borderRadius: 5, marginLeft: 20 }}
                        buttonStyle={{ borderRadius: 5 }}
                      />
                      :
                      <CircularProgress />
                  }
                </div>
              </div>
            </CardText>
          </Card>
        </div>
      </div>
    );
  }
}


DetalleSolicitud.propTypes = {
  idSolicitudDetalle: PropTypes.number.isRequired,
  prestaciones: PropTypes.array.isRequired,
  prestaciones2: PropTypes.array,
  prestaciones3: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  fechaSolicitud: PropTypes.string.isRequired,
  tipoSolicitud: PropTypes.number.isRequired,
  estadoSolicitud: PropTypes.number.isRequired,
  fechaResolucion: PropTypes.string.isRequired,
  tiposSolicitud: PropTypes.array.isRequired,
  estadosSolicitud: PropTypes.array.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  loadingFile: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  idSolicitudDetalle: state.grillaSolicitudes.idSolicitudDetalle,
  prestaciones: state.detalleSolicitudSR.prestaciones,
  prestaciones2: state.detalleSolicitudSR.prestaciones2,
  prestaciones3: state.detalleSolicitudSR.prestaciones3,
  fechaSolicitud: state.detalleSolicitudSR.fechaSolicitud,
  tipoSolicitud: state.detalleSolicitudSR.tipoSolicitud,
  estadoSolicitud: state.detalleSolicitudSR.estadoSolicitud,
  fechaResolucion: state.detalleSolicitudSR.fechaResolucion || "",
  tiposSolicitud: state.global.tiposSolicitud,
  estadosSolicitud: state.global.estadosSolicitud,
  rutInstitucion: state.global.rutInstitucion,
  loadingFile: state.detalleSolicitudSR.loadingFile,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(DetalleSolicitud);
